import { useTheme } from '@mui/material/styles';

import type { QuestionLibraryError } from '../../utils/errorHandling';

type QuestionLibraryErrorMessageProps = {
  error: QuestionLibraryError;
};

export default function QuestionLibraryErrorMessage({
  error,
}: Readonly<QuestionLibraryErrorMessageProps>) {
  const theme = useTheme();

  const message = error.errorMessage ?? 'Required';

  return (
    <div style={{ marginTop: '.3rem', border: '1p solid black' }}>
      <p
        style={{
          color: theme.palette.error.main,
          textAlign: 'left',
          fontSize: '0.875rem',
        }}
      >
        {message}
      </p>
    </div>
  );
}
